import moment from "moment";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";
import { Calendar } from "@/components/ui/calendar/calendar";

import useDate from "./useDate";
import { Button } from "@/components/ui/button/button";
import { cn } from "@/lib/utils";
import { CalendarIcon } from "lucide-react";

export const DateRangePicker = () => {
  const { selectedDate, changeDate, formattedDate } = useDate();

  const handleDateChange = (date: Date) => {
    changeDate(moment(date));
  };

  return (
    <>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn(
              "w-[260px] justify-start text-left font-normal",
              !selectedDate && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {formattedDate}
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <div>
            <Calendar
              mode="single"
              selected={selectedDate.toDate()}
              onSelect={(date) => {
                handleDateChange(date as Date);
              }}
            />
          </div>
        </PopoverContent>
      </Popover>
    </>
  );
};
